import React, { useEffect } from "react";

const DisplayNumber = (props) => {
  return (
    <div className="col-sm-6 col-md-3 col-lg-3 col-xl-3">
      <div className="single-count">
        <i>
          <img src={props.image} alt="" />
        </i>
        <div className="counter">
          <span className="odometer">{props.number}</span>
          <sup>+</sup>
        </div>
        <p>{props.name}</p>
      </div>
    </div>
  );
};
const ClientsCard = () => {
  return (
    <div className="features-count">
      <div className="row">
        <DisplayNumber
          name="Registered Job Seekers"
          number={28000}
          image="img/icons/count-1.png"
        />
        <DisplayNumber
          name="Emigrants Dispatched"
          number={12000}
          image="img/icons/count-2.png"
        />
        <DisplayNumber
          name="Countries"
          number={10}
          image="img/icons/count-3.png"
        />
        <DisplayNumber
          name="Clients"
          number={20}
          image="img/icons/count-4.png"
        />
      </div>
    </div>
  );
};

export default ClientsCard;
